module.exports = __webpack_public_path__ + "img/18.70651d06.svg";